export var APP_VERSION = "(v1.123)";
export var APP_ENV = "dev";
export var API_URL = "https://api.dev.k4mobility.com"
export var AUTH_URL = "https://auth.dev.k4mobility.com";